import React from 'react';
import WatchlistReact from './WatchlistReact';

const Watchlist: React.FC = () => {
  return <WatchlistReact />;
};

export default Watchlist;
